import comp from "./FeedListv2";
export default comp;
